export default __webpack_public_path__ + "static/media/weapon2.cc416141.png";